import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import { GIT_HASH } from './git-hash.js'
import errorLogger from './services/errorLogger'
import firebaseFunctionsInterceptor from './services/firebaseFunctionsInterceptor'

Vue.config.productionTip = false
Vue.prototype.$gitHash = GIT_HASH

// Debug mode utility - checks for ?debug=true URL parameter
Vue.prototype.$isDebugMode = () => {
  if (typeof window !== 'undefined' && window.location) {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('debug') === 'true'
  }
  return false
}

// Debug logger - only logs when debug mode is enabled
Vue.prototype.$debugLog = (...args) => {
  if (Vue.prototype.$isDebugMode()) {
    console.log(...args)
  }
}

// Global error handling
Vue.config.errorHandler = (err, vm, info) => {
  console.error('Vue error:', err, info)
  errorLogger.logError(err, {
    componentInfo: info,
    componentName: (vm && vm.$options && vm.$options.name) || 'Unknown',
    route: (vm && vm.$route && vm.$route.name) || 'Unknown'
  }, 'vue')
}

// Global unhandled JavaScript errors
window.onerror = (message, source, lineno, colno, error) => {
  const errorObj = error || new Error(message)
  errorLogger.logError(errorObj, {
    source,
    lineno,
    colno
  }, 'javascript')
  return false // Don't prevent default browser error handling
}

// Global unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason instanceof Error ? event.reason : new Error(event.reason)
  errorLogger.logError(error, {
    promiseRejection: true
  }, 'promise')
})

// Initialize Firebase Functions interceptor
firebaseFunctionsInterceptor.init()

// Make error logger available globally
Vue.prototype.$errorLogger = errorLogger

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
